<template>
  <div class="katalog view container bottom-nav-spacing">
    <title-bar :with-logo="false"
               :use-container="false"
               :title="_('Kontakt')"/>

    <div class="row ">
      <div class="col-xs-12 ">
        <div class="headline headline-page">
          <h1>{{ _('WIR HELFEN IHNEN GERNE WEITER') }}</h1>
          <div class="sub-headline">{{ _('Einfach Kontakt aufnehmen') }}</div>
        </div>

        <div class="bs4-row">
          <div class="bs4-col-12 bs4-col-lg-6">
            <label for="contact_country" style="margin: 0;">{{ _('Land') }}</label>
            <select
                id="contact_country"
                v-model="contactCountry"
                name="brand"
                class="color-blue spacer-bottom"
                @change="onCountryChange"
            >
              <option value="">{{ _('Land wählen') }}</option>
              <option v-for="country in countries" :value="country.slug">
                {{ country.name }}
              </option>
            </select>
          </div>
          <div class="bs4-col-12 bs4-col-lg-6">
            <label for="contact_section" style="margin: 0;">{{ _('Bereich') }}</label>
            <select id="contact_section"
                    v-model="contactCategory"
                    name="brand"
                    class="color-blue spacer-bottom">
              <option value="">{{ _('Bereich wählen') }}</option>
              <option v-for="(category, key) in effectiveDepartments" :value="key">
                {{ category }}
              </option>
            </select>
          </div>
        </div>

        <img src="@/img/hensel-loading.svg" alt="loading" style="margin: 0 auto; display: block" v-if="loading">
        <div class="row contact-wrapper spacer-bottom" v-else>
          <div v-for="contact in contactsForDepartment"
               class="col-xs-12 col-sm-6 col-lg-3"
          >
            <div class="contact-list-contact box">
              <div class="box-inner">
                <div class="row">
                  <div class="col-xs-4">
                    <div class="image-container">
                      <img :src="contact.image_url || 'https://hensel-recycling.com/wp-content/uploads/2020/12/contact_placeholder.png'" alt="" class="img-responsive">
                    </div>
                  </div>
                  <div class="col-xs-8">
                    <div class="headline">{{ contact.name }}</div>
                    <div class="sub-headline" v-if="contact.position">{{ contact.position }}</div>
                    <div class="line" v-if="contact.phone">{{ _('Telefon:') }} {{ contact.phone }}</div>
                    <div class="line" v-if="contact.fax">{{ _('Fax:') }} {{ contact.fax }}</div>
                    <div class="line"><b>{{ _('E-Mail:') }}</b> <a :href="'mailto:' + contact.email">{{
                        contact.email
                      }}</a></div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//Vuex
import { mapState } from 'vuex'
//Mixins
import forwardEvents from '@/mixins/forwardEvents.js'
//Components
import TitleBar from '../components/TitleBar'
import Modal from '../components/Modal'
import { BulmaAccordion, BulmaAccordionItem } from 'vue-bulma-accordion'
import CombinedImage from '../components/CombinedImage'
import PinchZoomOverlay from '../components/PinchZoomOverlay'
import KatListItem from '../components/KatListItem'

const availableLanguages = ['de', 'en', 'fr', 'es', 'it']

export default {
  name: 'Contact',
  mixins: [forwardEvents],
  components: { KatListItem, PinchZoomOverlay, CombinedImage, BulmaAccordion, BulmaAccordionItem, Modal, TitleBar },
  data () {
    return {
      loading: false,
      contacts: [],
      contactCountry: '',
      contactCategory: '',
      countries: [],
      departments: [],
    }
  },
  computed: {
    ...mapState({
      'user': state => state.Api.Users.current,
      'language': state => state.Api.Localizations.language,
    }),
    effectiveLanguage () {
      return availableLanguages.find(el => el === this.language) || 'en'
    },
    contactsForDepartment () {
      return this.contacts
          .filter(contact => this.contactDepartments(contact).find(
              department => department.contact_person_department === this.contactCategory))
    },
    availableDepartments () {
      return this.contacts
          .flatMap(contact => this.contactDepartments(contact).map(department => department.contact_person_department))
          .filter((id, index, arr) => index === arr.indexOf(id))
          .sort((a, b) => parseInt(a) - parseInt(b))
    },
    effectiveDepartments () {
      return this.availableDepartments
          .map(department => ({ [department]: this.departments[department] }))
          .reduce((accu, current) => ({ ...accu, ...current }), {})
    },
  },
  methods: {
    contactDepartments(contact) {
      if (Array.isArray(contact.department)) {
        return contact.department
      } else if (typeof contact.department === 'object') {
        return Object.values(contact.department)
      } else {
        return []
      }
    },
    async onCountryChange () {
      if (!this.contactCountry) {
        return
      }

      try {
        this.loading = true

        this.contactCategory = ''

        this.contacts = Object.values((await (await fetch(
            `https://hensel-recycling.com/wp-json/b2/v1/contacts/${this.contactCountry}?lang=${this.effectiveLanguage}`)).json()).data)
      } finally {
        this.loading = false
      }
    },
  },
  async mounted () {
    if (!this.user) {
      this.$router.push({ name: 'Login' })
      return
    }

    try {
      this.loading = true

      this.countries = (await (await fetch(
          `https://hensel-recycling.com/wp-json/b2/v1/countries?lang=${this.effectiveLanguage}`)).json()).data
      this.departments = (await (await fetch(
          `https://hensel-recycling.com/wp-json/b2/v1/departments?lang=${this.effectiveLanguage}`)).json()).data
    } finally {
      this.loading = false
    }
  },
}
</script>

<style>
label {
  margin: 0;
  line-height: 1em;
  -webkit-transform: translateY(5px);
  transform: translateY(5px);
  font-weight: normal;
}

.box-inner {
  border: 1px solid #e2e2e2;
  padding: 1.39em;
  background-color: #fff
}

.contact-list-contact {
  font-size: .83em;
  margin-bottom: 1em;
}

.contact-list-contact .box-inner .headline {
  font-size: 1.2em;
  text-transform: none
}

.image-container {
  aspect-ratio: 1;
  background-color: #ccc;
  border-radius: 50%;
  overflow: hidden;
}

.headline {
  font-weight: bold;
}

.sub-headline {
  margin-bottom: 1em
}

.contact-list-contact-full .sub-headline {
  font-family: "Helvetica Neue LT W01_67 Md Cn", Helvetica, Arial, sans-serif;
  font-weight: 400
}
</style>
